import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OpsAlarmsPageService {
    openAlarmMonitoring = new Subject<void>();

    openAlarmMonitoringPage() {
        this.openAlarmMonitoring.next();
    }
}
